export const PRINT_BEGIN = 'PRINT_BEGIN';
export const PRINT_END = 'PRINT_END';

const pixelsPerMil = 3.7795275591;
export const A4 = { width: 210 * pixelsPerMil, height: 297 * pixelsPerMil };



// WEBPACK FOOTER //
// ./src/constants/print.js